export default __webpack_public_path__ + "static/media/left-arrow-date.5ecdea42.svg";